import { analyzeFullSite as analyzeFullSiteReq } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/http';
export const analyzeFullSite = async (httpClient, errorHandler) => {
  const {
    withErrorHandler
  } = errorHandler;
  const response = await withErrorHandler(async () => httpClient.request(analyzeFullSiteReq({})), {
    errorCodesMap: {}
  });
  return response;
};
//# sourceMappingURL=analyze-full-site.js.map